import React, { Component } from "react";
import { Table, Button, Message, Label } from "semantic-ui-react";

class GeneralLedgerEntryPrintReport extends Component {
  render() {
    const { transactions, total, totalDebit, totalCredit,closingTotalReceivable,closingTotalIncome,closingTotalExpense,closingTotalNetAmount,totalReceivable,totalPayable,totalIncome,totalExpense,netAmount } = this.props;
   
    return (
      <React.Fragment>
      <Table celled fixed singleLine>
        <Table.Header>
        <Table.Row>
          <Table.HeaderCell colSpan="6" style={{ textAlign:"center" }}>General Ledger</Table.HeaderCell>
        </Table.Row>

          <Table.Row>
            <Table.HeaderCell width={2}>Date</Table.HeaderCell>
            <Table.HeaderCell width={6}>Description</Table.HeaderCell>
            <Table.HeaderCell width={2}>Type</Table.HeaderCell>
            <Table.HeaderCell width={2}>Debit</Table.HeaderCell>
            <Table.HeaderCell width={2}>Credit</Table.HeaderCell>
            <Table.HeaderCell width={2}>Balance</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {transactions.map(transaction => (
            <Table.Row>
              <Table.Cell>{transaction.date}</Table.Cell>
              <Table.Cell style={{ whiteSpace: 'pre-line' }}>{transaction.description}</Table.Cell>
              <Table.Cell>{transaction.type}</Table.Cell>
              <Table.Cell>
                {transaction.transaction === "Debit"
                  ? transaction.total
                  : 0}
              </Table.Cell>
              <Table.Cell>
                {" "}
                {transaction.transaction === "Credit"
                  ? transaction.total
                  : 0}
              </Table.Cell>
              <Table.Cell>{transaction.balance}</Table.Cell>
            </Table.Row>
          )
          )}

          <Table.Row>
            <Table.Cell></Table.Cell>
            <Table.Cell></Table.Cell>
            <Table.Cell></Table.Cell>
            <Table.Cell><b>{totalDebit}</b></Table.Cell>
            <Table.Cell style={{ textAlign: "left" }}><b>{totalCredit}</b></Table.Cell>
            <Table.Cell><b>{totalDebit - totalCredit}</b></Table.Cell>
          </Table.Row>

        </Table.Body>
      </Table>
      {totalReceivable  ?
      <React.Fragment>
      {/* <Table celled fixed singleLine>
        <Table.Header>
        <Table.Row>
          <Table.HeaderCell colSpan="5" style={{ textAlign:"center" }}>System Opening Statistics</Table.HeaderCell>
        </Table.Row>

          <Table.Row>
            <Table.HeaderCell width={3}>Total Receiveable</Table.HeaderCell>
            <Table.HeaderCell width={3}>Total Payable</Table.HeaderCell>
            <Table.HeaderCell width={3}>Total Received</Table.HeaderCell>
            <Table.HeaderCell width={3}>Total Paid</Table.HeaderCell>
            <Table.HeaderCell width={3}>Net Amount</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
        
            <Table.Row>
              <Table.Cell>{totalReceivable}</Table.Cell>
              <Table.Cell>{totalPayable}</Table.Cell>
              <Table.Cell>{totalIncome}</Table.Cell>
              <Table.Cell>{totalExpense}</Table.Cell>
              <Table.Cell>{netAmount}</Table.Cell>
            </Table.Row>
          
        </Table.Body>
      </Table>  */}
      {/* <Table celled fixed singleLine>
      <Table.Header>
      <Table.Row>
        <Table.HeaderCell colSpan="5" style={{ textAlign:"center" }}>System Expected Closing Statistics</Table.HeaderCell>
      </Table.Row>

        <Table.Row>
          <Table.HeaderCell width={3}>Total Receiveable</Table.HeaderCell>
          <Table.HeaderCell width={3}>Total Payable</Table.HeaderCell>
          <Table.HeaderCell width={3}>Total Received</Table.HeaderCell>
          <Table.HeaderCell width={3}>Total Paid</Table.HeaderCell>
          <Table.HeaderCell width={3}>Net Amount</Table.HeaderCell>
        </Table.Row>
      </Table.Header>

      <Table.Body>
      
          <Table.Row>
            <Table.Cell>{closingTotalReceivable}</Table.Cell>
            <Table.Cell>{totalPayable}</Table.Cell>
            <Table.Cell>{closingTotalIncome}</Table.Cell>
            <Table.Cell>{closingTotalExpense}</Table.Cell>
            <Table.Cell>{closingTotalNetAmount}</Table.Cell>
          </Table.Row>
        
      </Table.Body>
    </Table> */}
    </React.Fragment>
      
      : ""}

{/* <Table celled fixed singleLine>
<Table.Header>
  <Table.Row>
    <Table.HeaderCell width={15} style={{ textAlign: "right" }}>
      {this.state.closingBalance != 0 ? (
        "Closing Balance: " +
        this.formatClosingBalance()
      ) : (
          <Button
            color="green"
            onClick={this.generateClosingBalance}
          >
            Generate Closing Balance
          </Button>
        )}

    </Table.HeaderCell>
  </Table.Row>
</Table.Header>
</Table> */}
</React.Fragment>
    );
  }
}
export default GeneralLedgerEntryPrintReport;
